import type { VfConfig } from '#types/config/components/vf'

export default {
  brandClasses: {
    searchBar: '<lg:(px-4 py-2 bg-grey-90)',
    suggestions: {
      item: 'shrink-0 gap-2 w-22 relative lg:(flex w-a)',
      picture: 'shrink-0 <lg:w-full',
      products: 'flex gap-x-4 w-full <lg:(px-4 overflow-x-auto) lg:(gap-x-6 gap-y-8 grid cols-2 w-134)',
      results: 'py-4 bg-white f-col gap-6 lg:px-8 md:(py-8 flex-row)',
      title: 'title-4 md:title-3',
      wrapper: 'w-full transition-opacity overflow-auto lg:(mt-2 w-208 shadow-lg)'
    }
  },
  lockBodyScroll: true,
  maxTopSearches: 3,
  mobileNavIconSize: 'lg',
  searchThreshold: 3
} satisfies VfConfig['search']
